import React, {useCallback, useMemo, useRef, useState} from 'react'
import {Outlines, useGLTF} from '@react-three/drei'
import {useThree} from '@react-three/fiber'
import {usePulsatingOutline} from '../hooks/usePulsatingOutline.jsx'
import {useAppStore} from '../stores/store.js'
import * as THREE from 'three'
import {INFO_PANEL_DATA, STRAWBERRY_BOX_PROPS} from '../utils/constants.jsx'
import {SelectionHover} from './SelectionHover.jsx'

export function StrawberryConsole(props) {
    const {nodes, materials} = useGLTF('./models/strawberryConsole2.glb')
    const strawberryRef = useRef(null)
    const [hovered, setHovered] = useState(false)
    const {camera, size} = useThree()

    const outlineThickness = usePulsatingOutline(0.01, 0.03, 2); // Adjust values as needed

    const customStrawberryMaterials = useMemo(() => {
        const result = {}
        Object.entries(materials).forEach(([name, originalMaterial]) => {
            result[name] = new THREE.MeshBasicMaterial({
                map: originalMaterial.map,
                color: originalMaterial.color,
            })
        })
        return result
    }, [materials])


    const handleClick = useCallback((event) => {
        event.stopPropagation()

        if (!strawberryRef.current || !camera || !size.width || !size.height) {
            console.warn('Click skipped: Missing refs, handlers, or camera/size info.')
            return
        }

        const {focusOnObject, selectObject} = useAppStore.getState()

        // Get World Position
        const worldPos = new THREE.Vector3()
        strawberryRef.current.getWorldPosition(worldPos)

        const cameraFocusOffset = new THREE.Vector3(2.5, 2, -5)
        focusOnObject(worldPos, cameraFocusOffset)
        selectObject(INFO_PANEL_DATA.strawberry.id)

    }, [camera, size])

    const handlePointerEnter = useCallback((e) => {
        e.stopPropagation()
        setHovered(true)
        document.body.style.cursor = 'pointer'
    }, [])

    const handlePointerOut = useCallback((e) => {
        e.stopPropagation()
        setHovered(false)
        document.body.style.cursor = 'default'
    }, [])

    return (
        <>
            <group {...props} dispose={null}>
                <mesh
                    geometry={nodes.strawberryJamCroissant_3.geometry}
                    material={customStrawberryMaterials.light_wood}
                >
                    <Outlines thickness={outlineThickness} color='white' screenspace={true}/>
                </mesh>
                <mesh
                    geometry={nodes.strawberryJamCroissant_2.geometry}
                    material={customStrawberryMaterials.console}
                />
                <mesh
                    geometry={nodes.strawberryJamCroissant_4.geometry}
                    material={customStrawberryMaterials.parenthese}
                />
                <mesh
                    geometry={nodes.strawberryJamCroissant_1.geometry}
                    material={customStrawberryMaterials.strawberryJamCroissant}
                />
            </group>
            <mesh
                position={STRAWBERRY_BOX_PROPS.position}
                scale={STRAWBERRY_BOX_PROPS.scale}
                ref={strawberryRef}
                onPointerEnter={handlePointerEnter}
                onPointerOut={handlePointerOut}
                onClick={handleClick}
            >
                <boxGeometry/>
                <meshBasicMaterial
                    visible={false}
                    // color='blue'
                    // opacity={0.5}
                    // transparent={true}
                />
            </mesh>

            <SelectionHover
                objectRef={strawberryRef}
                hovered={hovered}
                cornerSize={0.5}
                padding={0.02}
            />
        </>
    )
}

useGLTF.preload('./models/strawberryConsole2.glb')